var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_180219",
    "data-name": "Group 180219",
    transform: "translate(-244 -147)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146603",
    "data-name": "Rectangle 146603",
    width: 32,
    height: 32,
    rx: 6,
    transform: "translate(244 147)",
    fill: "#f2f6fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29633",
    "data-name": "Path 29633",
    d: "M11.034,3.5A2.67,2.67,0,0,1,14,3.433a7.517,7.517,0,0,1,.971.9,7.512,7.512,0,0,1,.9.971,2.669,2.669,0,0,1-.07,2.963,8.542,8.542,0,0,1-.949,1.021L14,10.134a.684.684,0,0,0,.967.967l.846-.846.059-.059a8.861,8.861,0,0,0,1.055-1.161,4.037,4.037,0,0,0,.082-4.483A7.867,7.867,0,0,0,16,3.426l-.061-.061L15.875,3.3A7.86,7.86,0,0,0,14.748,2.29a4.037,4.037,0,0,0-4.483.082A8.852,8.852,0,0,0,9.1,3.427l-.059.059L8.2,4.332a.684.684,0,0,0,.967.967l.846-.846A8.534,8.534,0,0,1,11.034,3.5ZM5.3,9.167A.684.684,0,0,0,4.332,8.2l-.846.846L3.427,9.1a8.851,8.851,0,0,0-1.055,1.161,4.037,4.037,0,0,0-.082,4.483A7.866,7.866,0,0,0,3.3,15.875l.061.061L3.426,16a7.858,7.858,0,0,0,1.127,1.014,4.037,4.037,0,0,0,4.483-.082A8.85,8.85,0,0,0,10.2,15.874h0l.059-.059.846-.846A.684.684,0,0,0,10.134,14l-.846.846a8.524,8.524,0,0,1-1.021.949,2.67,2.67,0,0,1-2.963.07,7.536,7.536,0,0,1-.971-.9,7.515,7.515,0,0,1-.9-.971,2.67,2.67,0,0,1,.07-2.963,8.536,8.536,0,0,1,.949-1.021Zm7.253-1.451a.684.684,0,1,0-.967-.967L6.75,11.584a.684.684,0,1,0,.967.967Z",
    transform: "translate(250.35 153.35)",
    fill: "#203662",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonblue);
export default __webpack_public_path__ + "static/media/Buttonblue.52a8c2a41a49629d57d702266f1b1348.svg";
export { ForwardRef as ReactComponent };